<template>
  <div class="my-feedback">
    <!-- <div class="title">
      <van-nav-bar title="我的反馈">
        <van-icon
          name="arrow-left"
          slot="left"
          @click="Back()"
        />
      </van-nav-bar>
    </div> -->
    <loading v-if="loading"></loading>
    <div v-show="noList">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了..." @load="onLoad" :offset="160">
        <div class="list">
          <div class="list-item" v-for="(item, index) in list" :key="index">
            <div class="right">
              <div class="time">
                {{ item.addTime | dateFrm('YYYY-MM-DD HH:mm:ss') }}
              </div>
              <div class="problem">{{ item.opinionQuestion }}</div>
              <div class="feedImg" v-for="(x, i) in item.galleryVos" :key="i">
                <van-image width="80" height="80" :src="x.imageUrl" @click="imgBig(item, i)" />
              </div>
              <div class="answer" v-if="item.opinionAnswer !== null">
                <div>
                  <p><span>成都绿道客服</span> 的回复</p>
                  <p>{{ item.opinionAnswer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="no-list" v-if="!noList">
      <div>
        <van-image :src="noListIcon" width="250px"></van-image>
        <p>没有任何内容，快去反馈问题吧!</p>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
import { ImagePreview } from 'vant';
import Loading from '@/components/loading';
export default {
  data() {
    return {
      loading: false, // 加载动画
      finished: false,
      list: [],
      pageNum: 0,
      noList: false,
      noListIcon: require('../../assets/img/data_empty.png'),
    };
  },
  components: {
    Loading,
  },
  mounted() {
    document.title = '我的反馈';
    this.onLoad();
  },
  methods: {
    // 返回上一页
    Back() {
      this.$router.go(-1);
    },
    onLoad() {
      // 异步更新数据
      this.pageNum = this.pageNum + 1;
      this.getSuggestList();
    },
    //我的反馈列表
    getSuggestList() {
      this.loading = true;
      let data = {
        pageNum: this.pageNum,
        userId: localStorage.getItem('uid'),
      };
      this.$request
        .post('/appserver/v1/opinion/list', qs.stringify(data))
        .then((data) => {
          if (data.data.ret == 0) {
            if (data.data.data !== null) {
              if (data.data.data.list == null) {
                this.loading = false;
                this.finished = true;
                this.noList = false;
              } else {
                if (data.data.data.list.length == 0) {
                  this.noList = false;
                  this.loading = false;
                  this.finished = true;
                  this.finishedText = '';
                } else {
                  this.noList = true;
                  // 异步更新数据
                  setTimeout(() => {
                    let rows = data.data.data.list;
                    for (let i = 0; i < rows.length; i++) {
                      this.list.push(rows[i]);
                    }
                    // 加载状态结束
                    this.loading = false;
                    // 数据全部加载完成
                    if (this.list.length >= data.data.data.pagination.total) {
                      this.finished = true;
                    }
                  }, 500);
                }
              }
            } else {
              this.loading = false;
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        });
    },
    //图片反馈
    imgBig(item, index) {
      let imgArr = item.galleryVos;
      let newArr = [];
      for (let i = 0; i < imgArr.length; i++) {
        newArr.push(imgArr[i].imageUrl);
      }
      ImagePreview({
        images: newArr,
        startPosition: index,
        showIndex: false,
        onClose() {
          // do something
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.my-feedback {
  width: 100%;
  height: 100%;
  .title {
    /deep/ .van-nav-bar .van-icon {
      color: #4a4a4a;
      font-size: 22px;
      font-weight: 600;
    }
    /deep/ .van-nav-bar__title {
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 600;
    }
    /deep/ [class*="van-hairline"]::after {
      border: 0px;
    }
  }
  .list {
    width: 100%;
    .list-no {
      width: 100%;
      height: 260px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      p {
        font-size: 12px;
        font-family: PingFangSC-Light, PingFangSC;
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }
    }
    .list-item {
      padding: 20px;
      display: flex;
      justify-content: flex-start;
      border-bottom: 1px solid #eeeeee;
      .right {
        font-family: PingFangSC-Medium, PingFangSC;
        width: 100%;
        overflow: hidden;
        .time {
          margin-top: 7px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
        }
        .problem {
          margin-top: 12px;
          font-size: 16px;
          font-weight: 700;
          color: rgba(55, 56, 77, 1);
          // line-height: 16px;
        }
        .feedImg {
          margin: 10px 0;
          height: 80px;
          float: left;
          .van-image {
            margin-right: 10px;
          }
        }
        .answer {
          width: 100%;
          clear: both;
          margin-top: 10px;
          padding: 15px 12px;
          background: #f8f8f8;
          & > div {
            & > p {
              &:nth-of-type(1) {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFangSC;
                font-weight: 600;
                color: rgba(153, 153, 153, 1);
                line-height: 14px;
                & > span {
                  color: rgba(24, 131, 87, 1);
                }
              }
              &:nth-of-type(2) {
                margin-top: 15px;
                font-size: 15px;
                font-family: PingFangSC-Light, PingFangSC;
                color: rgba(55, 56, 77, 1);
                line-height: 23px;
              }
            }
          }
        }
      }
    }
  }
  .no-list {
    margin-top: 68px;
    display: flex;
    justify-content: center;
    & > div {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      & > p {
        width: 100%;
        text-align: center;
        margin-top: 19px;
        font-size: 14px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(155, 155, 155, 1);
      }
    }
  }
}
</style>
